"use client";

import { useCollector } from "next-collect/client";

export const useTelemetry = useCollector;
